module.exports = {
      id: "comm-spiritual-usage",
      viewBox: "0 0 271.278 58.643",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#comm-spiritual",
      toString: function () {
        return this.url;
      }
    }